export const stageLabels = { submitted: 'Sent — accepted by WhatsApp, not delivered', rejected: 'Rejected', not_sent: 'Not sent', reconciliation_required: 'Being checked' };
